var _style, _g, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoIconCyberpunk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "logo-icon-cyberpunk_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 188 188",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".logo-icon-cyberpunk_svg__st1{fill:#0ff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-icon-cyberpunk_svg__g32",
    transform: "translate(0 -8)",
    fill: "#0ff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    className: "logo-icon-cyberpunk_svg__st1",
    d: "m 3.3,141.6 h 3 v 22.7 h -3 c 0,0 0,-22.7 0,-22.7 z",
    id: "logo-icon-cyberpunk_svg__path12",
    fill: "#0ff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo-icon-cyberpunk_svg__st1",
    d: "M 32.5,165 15,147.2 l 0.9,0.2 0.1,16.9 h -3 v -23.4 0 l 17.3,17.9 -0.7,-0.2 -0.1,-17 h 3 z",
    id: "logo-icon-cyberpunk_svg__path14",
    fill: "#0ff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo-icon-cyberpunk_svg__st1",
    d: "m 39.2,164.3 v -22.7 h 6.2 c 2.3,0 4.2,0.3 5.8,1 1.6,0.7 2.8,1.6 3.8,2.7 1,1.1 1.7,2.4 2.1,3.8 0.4,1.4 0.7,2.7 0.7,4.1 0,1.7 -0.3,3.3 -0.9,4.6 -0.6,1.4 -1.4,2.5 -2.5,3.5 -1.1,1 -2.2,1.7 -3.6,2.2 -1.4,0.5 -2.8,0.8 -4.3,0.8 z m 3,-2.9 h 3.7 c 1.2,0 2.4,-0.2 3.4,-0.6 1.1,-0.4 2,-0.9 2.8,-1.6 0.8,-0.7 1.4,-1.6 1.8,-2.6 0.4,-1 0.7,-2.2 0.7,-3.6 0,-1.4 -0.2,-2.6 -0.7,-3.7 -0.5,-1.1 -1.1,-1.9 -1.9,-2.7 -0.8,-0.7 -1.7,-1.3 -2.7,-1.6 -1,-0.4 -2.1,-0.5 -3.1,-0.5 h -4 z",
    id: "logo-icon-cyberpunk_svg__path16",
    fill: "#0ff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo-icon-cyberpunk_svg__st1",
    d: "m 65.6,156.3 c 0,1 0.2,1.9 0.7,2.8 0.5,0.8 1.2,1.4 2,1.9 0.8,0.5 1.7,0.7 2.8,0.7 1.1,0 2,-0.2 2.9,-0.7 0.8,-0.5 1.5,-1.1 2,-1.9 0.5,-0.8 0.7,-1.7 0.7,-2.8 v -14.7 h 3 v 14.8 c 0,1.7 -0.4,3.1 -1.1,4.3 -0.8,1.2 -1.8,2.2 -3.1,2.9 -1.3,0.7 -2.7,1 -4.3,1 -1.6,0 -3,-0.3 -4.3,-1 -1.3,-0.7 -2.3,-1.6 -3.1,-2.9 -0.8,-1.2 -1.1,-2.7 -1.1,-4.3 v -14.8 h 3 z",
    id: "logo-icon-cyberpunk_svg__path18",
    fill: "#0ff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo-icon-cyberpunk_svg__st1",
    d: "m 97.6,145.6 c -0.8,-0.4 -1.6,-0.7 -2.5,-1 -0.9,-0.3 -1.8,-0.4 -2.7,-0.4 -1.2,0 -2.2,0.3 -2.9,0.8 -0.7,0.6 -1.1,1.3 -1.1,2.3 0,0.7 0.2,1.3 0.7,1.8 0.5,0.5 1.1,0.9 1.8,1.3 0.7,0.4 1.5,0.7 2.4,1 0.7,0.3 1.4,0.5 2.1,0.9 0.7,0.4 1.3,0.8 1.9,1.3 0.6,0.5 1,1.1 1.3,1.9 0.3,0.7 0.5,1.6 0.5,2.7 0,1.2 -0.3,2.3 -0.9,3.3 -0.6,1 -1.5,1.8 -2.6,2.3 -1.1,0.6 -2.4,0.8 -4,0.8 -1,0 -1.9,-0.1 -2.8,-0.3 -0.9,-0.2 -1.8,-0.5 -2.5,-0.9 -0.8,-0.4 -1.5,-0.8 -2.1,-1.2 l 1.4,-2.4 c 0.5,0.4 1.1,0.7 1.7,1 0.6,0.3 1.3,0.6 2,0.8 0.7,0.2 1.4,0.3 2.1,0.3 0.7,0 1.4,-0.1 2.1,-0.4 0.7,-0.3 1.3,-0.6 1.7,-1.2 0.4,-0.6 0.7,-1.3 0.7,-2.2 0,-0.8 -0.2,-1.4 -0.6,-1.9 -0.4,-0.5 -0.9,-1 -1.6,-1.3 -0.7,-0.4 -1.4,-0.7 -2.2,-1 -0.7,-0.3 -1.5,-0.5 -2.2,-0.9 -0.7,-0.3 -1.4,-0.7 -2,-1.2 -0.6,-0.5 -1.1,-1.1 -1.5,-1.7 -0.4,-0.6 -0.6,-1.5 -0.6,-2.5 0,-1.2 0.3,-2.2 0.9,-3.1 0.6,-0.9 1.4,-1.6 2.4,-2.1 1,-0.5 2.2,-0.8 3.5,-0.8 1.5,0 2.8,0.2 3.9,0.5 1.1,0.4 2.1,0.8 3,1.3 z",
    id: "logo-icon-cyberpunk_svg__path20",
    fill: "#0ff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo-icon-cyberpunk_svg__st1",
    d: "m 102.2,141.6 h 15.1 v 2.9 h -6.1 v 19.8 h -3 v -19.8 h -6 z",
    id: "logo-icon-cyberpunk_svg__path22",
    fill: "#0ff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo-icon-cyberpunk_svg__st1",
    d: "m 128.2,141.6 c 1.2,0 2.2,0.2 3.2,0.5 1,0.3 1.8,0.8 2.5,1.4 0.7,0.6 1.3,1.3 1.7,2.2 0.4,0.9 0.6,1.9 0.6,3 0,0.9 -0.1,1.8 -0.4,2.6 -0.3,0.9 -0.7,1.6 -1.3,2.3 -0.6,0.7 -1.4,1.3 -2.4,1.7 -1,0.4 -2.2,0.6 -3.6,0.6 h -3.4 v 8.4 h -3 v -22.7 z m 0.3,11.4 c 0.9,0 1.6,-0.1 2.2,-0.4 0.6,-0.3 1.1,-0.6 1.4,-1.1 0.3,-0.5 0.6,-0.9 0.7,-1.4 0.1,-0.5 0.2,-1 0.2,-1.4 0,-0.4 -0.1,-0.9 -0.2,-1.4 -0.2,-0.5 -0.4,-0.9 -0.8,-1.4 -0.4,-0.5 -0.8,-0.8 -1.4,-1.1 -0.6,-0.3 -1.2,-0.4 -2,-0.4 h -3.5 v 8.5 z m 3.8,1.7 5.9,9.6 h -3.5 l -6.1,-9.5 z",
    id: "logo-icon-cyberpunk_svg__path24",
    fill: "#0ff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo-icon-cyberpunk_svg__st1",
    d: "m 142.9,141.6 h 3 v 22.7 h -3 z",
    id: "logo-icon-cyberpunk_svg__path26",
    fill: "#0ff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo-icon-cyberpunk_svg__st1",
    d: "m 152.5,141.6 h 14.8 v 2.9 h -11.7 v 6.9 H 166 v 3 h -10.5 v 7 h 12.2 v 2.9 h -15.2 z",
    id: "logo-icon-cyberpunk_svg__path28",
    fill: "#0ff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo-icon-cyberpunk_svg__st1",
    d: "m 184.7,145.6 c -0.8,-0.4 -1.6,-0.7 -2.5,-1 -0.9,-0.3 -1.8,-0.4 -2.7,-0.4 -1.2,0 -2.2,0.3 -2.9,0.8 -0.7,0.5 -1.1,1.3 -1.1,2.3 0,0.7 0.2,1.3 0.7,1.8 0.5,0.5 1.1,0.9 1.8,1.3 0.7,0.4 1.5,0.7 2.4,1 0.7,0.3 1.4,0.5 2.1,0.9 0.7,0.4 1.3,0.8 1.9,1.3 0.6,0.5 1,1.1 1.3,1.9 0.3,0.7 0.5,1.6 0.5,2.7 0,1.2 -0.3,2.3 -0.9,3.3 -0.6,1 -1.5,1.8 -2.6,2.3 -1.1,0.6 -2.4,0.8 -4,0.8 -1,0 -1.9,-0.1 -2.8,-0.3 -0.9,-0.2 -1.8,-0.5 -2.5,-0.9 -0.8,-0.4 -1.5,-0.8 -2.1,-1.2 l 1.4,-2.4 c 0.5,0.4 1.1,0.7 1.7,1 0.6,0.3 1.3,0.6 2,0.8 0.7,0.2 1.4,0.3 2.1,0.3 0.7,0 1.4,-0.1 2.1,-0.4 0.7,-0.3 1.3,-0.6 1.7,-1.2 0.4,-0.6 0.7,-1.3 0.7,-2.2 0,-0.8 -0.2,-1.4 -0.6,-1.9 -0.4,-0.5 -0.9,-1 -1.6,-1.3 -0.7,-0.4 -1.4,-0.7 -2.2,-1 -0.7,-0.3 -1.5,-0.5 -2.2,-0.9 -0.7,-0.3 -1.4,-0.7 -2,-1.2 -0.6,-0.5 -1.1,-1.1 -1.5,-1.7 -0.4,-0.7 -0.6,-1.5 -0.6,-2.5 0,-1.2 0.3,-2.2 0.9,-3.1 0.6,-0.9 1.4,-1.6 2.4,-2.1 1,-0.5 2.2,-0.8 3.5,-0.8 1.5,0 2.8,0.2 3.9,0.5 1.1,0.4 2.1,0.8 3,1.3 z",
    id: "logo-icon-cyberpunk_svg__path30",
    fill: "#0ff",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    "aria-label": "FC.",
    style: {
      lineHeight: 1.25,
      InkscapeFontSpecification: "'Blade Runner Movie Font, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start"
    },
    id: "logo-icon-cyberpunk_svg__text848",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 96.248,
    fontFamily: "Blade Runner Movie Font",
    letterSpacing: 0,
    wordSpacing: 0,
    writingMode: "lr-tb",
    textAnchor: "start",
    fill: "#0f0",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 2.406
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 88.947074,42.746184 84.327153,58.915907 H 21.861973 L 32.160546,42.746184 Z M 82.979676,65.17205 77.686017,82.785499 H 46.790296 L 39.57167,109.0613 H 14.258353 L 26.481894,65.17205 Z",
    id: "logo-icon-cyberpunk_svg__path850"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 155.16578,42.746184 -4.71617,16.169723 H 92.796852 q 1.828718,-6.159894 6.737384,-10.876064 5.486154,-5.293659 11.357304,-5.293659 z M 141.49852,91.351602 136.4936,109.2538 h -30.51072 q -15.880982,0 -20.212158,-10.106082 -1.347477,-3.079947 -0.866235,-8.566103 0.09625,-1.058732 0.384993,-3.849934 l 5.678653,-21.463383 23.869587,-0.09625 -6.92988,21.270886 q 0.28875,1.251228 0.57749,2.598705 0.86624,1.732471 3.56119,2.309961 z",
    id: "logo-icon-cyberpunk_svg__path852"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 155.06947,109.15755 4.04243,-14.052262 h 14.62975 l -3.94619,14.052262 z",
    id: "logo-icon-cyberpunk_svg__path854"
  }))));
}

export default SvgLogoIconCyberpunk;